import AppFormInput from '../../../components/ui/AppFormInput';
import React, { useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import { useHistory } from "react-router-dom";
import AnimatedSuccessGIF from "../../../assets/images/check-green.gif";
import { Toast } from "primereact/toast";

import apiClient from "../../../services/api-client";
import { useMountEffect } from "primereact/hooks";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const { userId, otp: urlOtp } = useParams();
  const [otp, setOtp] = useState("");
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const toast = useRef(null);
  const history = useHistory();

  useMountEffect(() => {
    if (urlOtp) {
      setOtp(urlOtp);
    }
  });

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword()) {
      setError("Please enter a valid password and confirm password.");
      return;
    }

    try {
      const response = await apiClient.post(`user/resetNewPassword/${userId}/${otp}`, {
        accessToken: "",
        operation: "set-new-password",
        requestBody: {
          password: password,
        },
      });

      if (response.data.status === "SUCCESS") {
        setRegistrationSuccess(true);
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.data.message,
          life: 4000,
        });
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Sorry, exception occured, contact admin",
        life: 4000,
      });
    }
  };

  const validatePassword = () => {
    return password !== "" && password === confirmPassword;
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="min-h-screen bg-[#F8FAFC] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          {!registrationSuccess ? (
            <>
              <div className="text-center mb-8 flex flex-col items-center">
                <Link to="/landing" className="flex items-center justify-center space-x-3 mb-6">
                  <img className="h-10 w-auto" src={logo} alt="Doves" />
                  <span className="bg-[#EBF5FF] text-[#135A9C] font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest">
                    Self-Service Portal
                  </span>
                </Link>
                <h1 className="text-2xl font-extrabold text-slate-800 mt-2 tracking-tight">Set a new password</h1>
                <p className="mt-2 text-sm text-slate-500">
                  Enter the OTP from your email and choose a new password.
                </p>
              </div>
              <div className="bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100">
                <form onSubmit={handleFormSubmit} className="space-y-4">
                  <AppFormInput
                    label="OTP"
                    type="text"
                    inputMode="numeric"
                    maxLength={6}
                    inputClassName="text-center tracking-[0.5em] font-mono font-bold"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    error={error}
                    required
                  />

                  <AppFormInput
                    label="Password"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    hint="At least 8 characters, with an uppercase letter, a number and a special character."
                  />

                  <AppFormInput
                    label="Confirm password"
                    type="password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={error}
                    required
                  />

                  <button
                    type="submit"
                    className="btn w-full rounded-full font-bold mt-2 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </>
          ) : (
            <div className="bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100 flex flex-col items-center text-center">
              <img className="w-24 h-24 mb-6" src={AnimatedSuccessGIF} alt="" />
              <h3 className="text-2xl font-extrabold text-slate-800 mb-2">Password Reset Successfully</h3>
              <p className="text-slate-500 mb-6">You can now sign in with your new password.</p>
              <button
                onClick={() => history.push("/signin")}
                className="btn rounded-full font-bold bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none px-8"
              >
                <i className="pi pi-check-circle mr-1" /> Ok
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
